import { useEffect, useState } from "react";
import {
  InitializeOptions,
  event as gaEvent,
  initialize,
  pageview,
} from "react-ga";
import { useLocation } from "react-router-dom";

export function useGATracking(
  gaTrackingId: string,
  options?: InitializeOptions
) {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (gaTrackingId && !initialized) {
      initialize(gaTrackingId, options);
      setInitialized(true);
    }
  }, [gaTrackingId, initialized, options]);

  useEffect(() => {
    if (initialized) {
      pageview(location.pathname);
    }
  }, [initialized, location]);

  return initialized;
}

interface Events {
  "Link Flow": "ExitIcon" | "ExitCTA";
}

export function useGATrackingEvent() {
  return {
    logGAEvent: <K extends keyof Events>(
      category: K,
      action: Events[K],
      companyId: string
    ) => {
      gaEvent({ category, action, dimension1: companyId });
    },
  };
}
